import { render, staticRenderFns } from "./PracticeIndex.vue?vue&type=template&id=4bca21cb&scoped=true&"
import script from "./PracticeIndex.vue?vue&type=script&lang=js&"
export * from "./PracticeIndex.vue?vue&type=script&lang=js&"
import style0 from "./PracticeIndex.vue?vue&type=style&index=0&id=4bca21cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bca21cb",
  null
  
)

export default component.exports